/* import __COLOCATED_TEMPLATE__ from './quick-reply-form.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    quickReplies: $TSFixMe;
    onQuickReplyChange: (propName: string, value: string) => void;
  };
}

const QuickReplyForm = templateOnlyComponent<Signature>();
export default QuickReplyForm;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Settings::QuickReplyForm': typeof QuickReplyForm;
    'ai-agent/settings/quick-reply-form': typeof QuickReplyForm;
  }
}
